import Phaser from 'phaser';

const createGhostAnims = (anims: Phaser.Animations.AnimationManager) => {
	anims.create({
		key: 'enemy1-idle',
		frames: anims.generateFrameNames('kebab_tiles', { start: 0, end: 1, prefix: 'enemy1', suffix: '.png' }),
		frameRate: 5,
		repeat: -1
	});
	anims.create({
		key: 'enemy2-idle',
		frames: anims.generateFrameNames('kebab_tiles', { start: 0, end: 1, prefix: 'enemy2', suffix: '.png' }),
		frameRate: 5,
		repeat: -1
	});
	anims.create({
		key: 'enemy3-idle',
		frames: anims.generateFrameNames('kebab_tiles', { start: 0, end: 1, prefix: 'enemy3', suffix: '.png' }),
		frameRate: 5,
		repeat: -1
	});
	anims.create({
		key: 'enemy4-idle',
		frames: anims.generateFrameNames('kebab_tiles', { start: 0, end: 1, prefix: 'enemy4', suffix: '.png' }),
		frameRate: 5,
		repeat: -1
	});
};

export default createGhostAnims;

export {
	createGhostAnims
};
